import {
  Alert,
  Box,
  HStack,
  Text,
  useToast,
  UseToastOptions
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FiWifiOff } from 'react-icons/fi'

import { useNetworkStatus } from '../hooks/useNetworkStatus'

export function useNetworkStatusNotifier() {
  const { t } = useTranslation()
  const toast = useToast()
  const toastId = 'network-toast'
  const { isOffline, isPoorConnection } = useNetworkStatus()

  const toastProps: UseToastOptions = {
    id: toastId,
    position: 'bottom',
    duration: null,
    render: () => (
      <Alert status="error" borderRadius="md" boxShadow="none" p={3}>
        <HStack spacing={3}>
          <FiWifiOff size="20px" color={'custom.gray.200'} />
          <Box>
            <Text textColor={'custom.gray.200'}>
              {isOffline ? t('offlineConnection') : t('poorConnection')}
            </Text>
          </Box>
        </HStack>
      </Alert>
    )
  }

  useEffect(() => {
    if (isOffline || isPoorConnection) {
      toast.isActive(toastId)
        ? toast.update(toastId, toastProps)
        : toast(toastProps)
    } else {
      toast.close(toastId)
    }
  }, [isOffline, isPoorConnection, toast, toastProps])
}
